import { render, staticRenderFns } from "./MoleculeTagSelector.vue?vue&type=template&id=28c0a15a&scoped=true"
import script from "./MoleculeTagSelector.vue?vue&type=script&lang=js"
export * from "./MoleculeTagSelector.vue?vue&type=script&lang=js"
import style0 from "./MoleculeTagSelector.vue?vue&type=style&index=0&id=28c0a15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c0a15a",
  null
  
)

export default component.exports